<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
        <h4> {{$t('Search')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-5">
        
       <p>{{$t('Category')}}</p>
          <v-select
            label="Name"
            class="mt-5 w-full"
            v-model="search.CourseCategoryID"
            :options="courseCategories" 
            :reduce="Category => Category.ID"
          />
<p>{{$t('Language')}}</p>
          <v-select
            label="Name"
            class="mt-5 w-full"
            v-model="search.LanguageID"
            :options="languages" 
            :reduce="Language => Language.ID"
          />
<p>{{$t('IndustrySector')}}</p>
          <v-select
            label="Name"
            class="mt-5 w-full"
            v-model="search.IndustrySectorID"
            :options="industrySectors" 
            :reduce="Sector => Sector.ID"
          />
<p>{{$t('AreaOfStudy')}}</p>
          <v-select
            label="Name"
            class="mt-5 w-full"
            v-model="search.AreaOfStudyID"
            :options="courseAreaOfStudyList" 
            :reduce="Area => Area.ID"
          />
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="searchYearSummery" >{{$t('Search')}}</vs-button>
       <vs-button type="border" class="mr-6" color="danger" @click="resetModel">{{$t('Reset')}}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('Cancel')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    search: {
      type: Object,
      default: () => {}
    }
  },

 

  data() {
    return {
   
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },

  computed: {
        courseCategories() {
      return this.$store.state.courseCategoryList.courseCategories;
    },
     industrySectors()
    {
        return this.$store.state.industrySectorList.industrySectors;
    },
    courseAreaOfStudyList()
    {
      return this.$store.state.courseAreaOfStudyList.courseAreaOfStudies;
    },
     languages()
    {
      return this.$store.state.languageList.languages;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
         
        }
      }
    },
  
  },

  methods: {
      resetModel(){
        debugger
         this.search.CourseCategoryID=null;
          this.search.IndustrySectorID=null;
           this.search.AreaOfStudyID=null;
            this.search.LanguageID=null;
            this.search={}
      },
    searchYearSummery()
    {
      this.$emit("closeSidebar",true);
    }
  },

  components: {
    VuePerfectScrollbar,
    vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
